import {Component, OnInit} from "@angular/core";
import {KeycloakService} from "keycloak-angular";
import {AuthService} from "../../services/auth.service";
import {EnvConfig} from "../../../environments/environment";
import {LanguageService} from "../../services/language.service";
import {tap} from "rxjs/operators";
import {italian} from "../../../assets/i18n/it-IT";
import {english} from "../../../assets/i18n/en-GB";

@Component({
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  homeDesc: any;

  public readonly EnvConfig = EnvConfig;

  constructor(
    public authService: AuthService,
    private keycloakService: KeycloakService,
    private languageService: LanguageService,
    // private readonly tracker: MatomoTracker
  ) {
  }
  ngOnInit() {
    this.languageService.selectedLang$.pipe(
      tap((data) => {
        if (data?.code.slice(0, 2) === 'en') {
          this.homeDesc = english;
        } else {
          this.homeDesc = italian;
        }
      })
    ).subscribe();
  }

  loginSPID(): void {
    this.keycloakService.login({
      redirectUri: `${window.location.origin}/form`
    });
  }
}
